<template>
    <div>
        <div class="headline">Теми занять</div>
        <v-btn class="mt-2 mb-4" color="primary" text 
               :to="{name: 'topicsPlan', params: {department: $route.params.department, subject: $route.params.subject, module: $route.params.module}}"
        >Перейти до внесення тем в Панелі модератора <v-icon>arrow_forward</v-icon></v-btn>
        <v-data-table
                :headers="headers"
                :items="items"
                :server-items-length="total"
                :loading="loading"
                :options.sync="pagination"
                class="elevation-3"
                :footer-props="{
                    itemsPerPageOptions: [10, 25, 50, 100, {text: 'Всі', value: -1}]
                }"
        >
            <template v-slot:item.navigation="{item}">
                <div class="justify-center d-flex">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="$emit('navigateTo', item.id, 'eAristoEducationalTopicContent')"
                                   v-on="on" icon class="mx-0">
                                <v-icon color="blue">send</v-icon>
                            </v-btn>
                        </template>
                        <span>Перейти до змісту індивідуальної роботи</span>
                    </v-tooltip>
                </div>
            </template>

            <template v-slot:item.eAristoContent="{item}">
                <div  style="min-width: 100px;">
                    <span v-if="item.hasInteractiveVideo" class="mr-2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{on}">
                                <v-icon color="primary" v-on="on">video_library</v-icon>
                            </template>
                            <span>Інтерактивне відео</span>
                        </v-tooltip>
                    </span>

                    <span v-if="item.hasInteractivePresentation" class="mr-2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{on}">
                                <v-icon color="primary" v-on="on">photo_library</v-icon>
                            </template>
                            Інтерактивна презентація
                        </v-tooltip>
                    </span>

                    <span v-if="item.hasTopicQuestions" class="mr-2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{on}">
                                <v-icon color="primary" v-on="on">quiz</v-icon>
                            </template>
                            Тестування по темі
                        </v-tooltip>
                    </span>
                </div>
            </template>
            
            <template v-slot:item.isBlocked="{item}">
                <v-icon v-if="!item.isBlocked">radio_button_unchecked</v-icon>
                <v-icon v-if="item.isBlocked">radio_button_checked</v-icon>
            </template>
            
            <template v-slot:item.evaluationMode="{item}">
                {{getEvaluationModeType(item.evaluationMode)}}
            </template>
        </v-data-table>
    </div>
</template>
<script>
    import topicEvaluationModeTypes, {topicEvaluationModeEnum} from "../../../constants/topicEvaluationModeTypes";

    export default {
        props: {
            items: {
                type: Array,
            },
            total: {
                type: Number,
            },
            loading: {
                type: Boolean,
            },
        },
        watch: {
            pagination(paginationVal, prevPaginationVal) {
                this.$emit("paginate", paginationVal);
            },
        },
        methods: {
          getEvaluationModeType(type) {
              const foundEvaluationType = topicEvaluationModeTypes.find(i => i.id === type);
              
              if (foundEvaluationType) {
                  return foundEvaluationType.nameUk;
              }
              
              return "";
          }  
        },
        data: () => ({
            pagination: {
                totalItems: 0,
            },
            headers: [
                {text: 'Навігація', value: 'navigation', sortable: false},
                {text: '№ п/п', value: 'orderNumber'},
                {text: '№ заняття', value: 'classNumber'},
                {text: 'Назва (укр)', value: 'nameUk'},
                {text: 'Наповнення', value: 'eAristoContent', },
                // {text: 'Назва (eng)', value: 'nameEn'},
                {text: 'Академічні години', value: 'academicHours'},
                {text: 'Блокування', value: 'isBlocked'},
            ],
            topicEvaluationModeEnum,
        }),
    }
</script>